import { type KomboRejectionReason as KomboRejectionReasonResponse } from "../api";
import { Utility } from "./utility";

export interface KomboRejectionReason extends KomboRejectionReasonResponse {}

export class KomboRejectionReason extends Utility<KomboRejectionReason> {
  constructor(init?: Partial<KomboRejectionReason>) {
    super();
    Object.assign(this, init);
  }
}
